import { createAction, props } from '@ngrx/store';
import { LanguageType, LunePreferences } from '@icilalune/types';
import { Breakpoint } from '@icilalune/utils/responsive';

export const initCore = createAction('[Core] Init');

export const updateStandByToolBar = createAction(
  '[Core] update StandBy ToolBar',
  props<{ standBy: boolean }>()
);

export const setBreakpoint = createAction(
  '[Core] set breakpoint',
  props<{ breakpoint: Breakpoint | undefined }>()
);

export const setElevatorIndex = createAction(
  '[Core] set Elevator Index',
  props<{ index: number }>()
);

export const setElevatorRatio = createAction(
  '[Core] set Elevator Ratio',
  props<{ ratio: number }>()
);

export const switchLanguage = createAction(
  '[Core] Switch Language',
  props<{ language: LanguageType; path?: string }>()
);

export const setPreferences = createAction(
  '[Core] Set Preferences',
  props<{ preferences: LunePreferences | null }>()
);

export const savePreferences = createAction(
  '[Core] Save Preferences',
  props<{ preferences: LunePreferences }>()
);

export const appReady = createAction('[Core] App Ready');

export const loadMainMenu = createAction('[Core] Load Main Menu');

export const loadSecondaryMenu = createAction('[Core] Load Secondary Menu');

export const loadPreferences = createAction('[Core] Load Preferences');

export const loadBusinessUnits = createAction('[Core] Load Business Units');

export const loadMainVocabularies = createAction(
  '[Core] Load Main Vocabularies'
);
